import { useState, useEffect } from "react";
import { getCurrentSeason, getPlSetupStatus } from "../api/premierLeague";

// Module-level cache so it's only fetched once per page load across all components
let _cached = null;
let _promise = null;

export function usePlSeason() {
  const [seasonId, setSeasonId] = useState(_cached?.id ?? null);
  const [loading, setLoading] = useState(!_cached);

  useEffect(() => {
    if (_cached) {
      setSeasonId(_cached.id);
      setLoading(false);
      return;
    }
    if (!_promise) {
      _promise = (async () => {
        const season = await getCurrentSeason();
        // During the pre-season setup window, return the upcoming season ID
        // so all pool pages use the correct season automatically
        try {
          const setup = await getPlSetupStatus();
          if (setup.setup_available && setup.next_season_id) {
            return { ...season, id: setup.next_season_id };
          }
        } catch (_) {}
        return season;
      })();
    }
    _promise.then((data) => {
      _cached = data;
      setSeasonId(data.id);
      setLoading(false);
    }).catch(() => {
      _promise = null;
      setSeasonId(5);
      setLoading(false);
    });
  }, []);

  return { seasonId, loading };
}
